import { useParams } from "react-router-dom";
import { EditIcon } from "components/atoms/Icon";
import { Button } from "components/atoms/Button";
import { Paragraph } from "components/atoms/Typography";
import Modal from "components/molecules/Modal";
import { useUpdateCustomPlanName } from "mutations/CustomPlans/useUpdateCustomPlanName";
import posthog from "posthog-js";
import { useMemo, useState } from "react";

import styles from "./EditCustomPlanButton.module.scss";

interface RenamePlanProps {
    buildingModelCarbonReductionPlan: BuildingModelCarbonReductionPlan;
}
function RenamePlanButton({ buildingModelCarbonReductionPlan }: RenamePlanProps) {
    const [showingModal, setShowingModal] = useState(false);
    const { planView } = useParams();

    if (buildingModelCarbonReductionPlan.planType !== "custom" || planView !== "custom") {
        return null;
    }

    return (
        <div style={{ display: "flex" }}>
            <button
                className={styles.addProjectButton}
                type="button"
                onClick={() => setShowingModal(true)}
                disabled={false}
            >
                <EditIcon color="black" width="15" height="15" />
                <Paragraph>Rename Plan</Paragraph>
            </button>
            <RenamePlanModal
                modalIsOpen={showingModal}
                onCancel={() => {
                    setShowingModal(false);
                }}
                buildingModelCarbonReductionPlan={buildingModelCarbonReductionPlan}
            />
        </div>
    );
}

interface RenamePlanModalProps {
    modalIsOpen: boolean;
    onCancel: () => void;
    buildingModelCarbonReductionPlan: BuildingModelCarbonReductionPlan;
}

function RenamePlanModal({ modalIsOpen, onCancel, buildingModelCarbonReductionPlan }: RenamePlanModalProps) {
    const [planName, setPlanName] = useState("");
    const { mutate, isLoading } = useUpdateCustomPlanName();
    const { buildingModelUid } = useParams();
    useMemo(() => {
        setPlanName(buildingModelCarbonReductionPlan.name);
    }, [buildingModelCarbonReductionPlan]);

    const onSubmit = () => {
        posthog.capture("Rename plan");
        mutate(
            {
                carbonReductionPlanId: buildingModelCarbonReductionPlan.id,
                name: planName,
                buildingModelUid: buildingModelUid || "",
            },
            {
                onSuccess: () => {
                    onCancel();
                },
            }
        );
    };

    const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const planName = e.target.value;
        setPlanName(planName);
    };

    const isInvalid = !planName.trim();

    return (
        <div>
            <Modal
                open={modalIsOpen}
                onCancel={onCancel}
                title="Rename plan"
                // className={styles.modalContainer}
                footer={
                    <div>
                        <div className="bulk-edit-tags__footer">
                            <Button type="primary" onClick={() => onSubmit()} disabled={isInvalid || isLoading}>
                                {isLoading ? "Saving..." : "Save"}
                            </Button>
                            {!isLoading && (
                                <Button
                                    type="link"
                                    onClick={onCancel}
                                    style={{ color: "var(--audette-black)" }}
                                    disabled={isLoading}
                                >
                                    Cancel
                                </Button>
                            )}
                        </div>
                    </div>
                }
            >
                <div>
                    <div
                    // className={styles.firstHeader}
                    >
                        <p>
                            Give this custom plan a new name.
                            <br />
                        </p>
                    </div>
                    <div className="form-input-wrapper">
                        <div>
                            <input
                                style={{
                                    width: "100%",
                                }}
                                placeholder="Enter a new plan name."
                                value={planName}
                                className="form-input"
                                onChange={handleNameChange}
                                disabled={isLoading}
                            />
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    );
}

export default RenamePlanButton;
